import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { NumeroReperibilitaDTO } from 'src/app/shared/dto/reperibilità/NumeroReperibilita';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/shared/GenericService';

@Injectable({
  providedIn: 'root'
})
export class NumeroService extends GenericService<NumeroReperibilitaDTO, number>{

  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/numeri';
  }

  public numeriList(pageNumber: number, pageSize: number, direction: string, sortField: string, descrizione: string): Observable<ResponseQueryByCriteria<NumeroReperibilitaDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    if (descrizione != null) params["descrizione"] = descrizione;
    return this.http.get<ResponseQueryByCriteria<NumeroReperibilitaDTO>>(`${this.url}/numeriList`, {
      params: params
    });
  }
}